module.exports = __webpack_public_path__ + "media/images/pekarska-video_noVW-d948056e.mp4";